import {
	generalInfoConstants, preAppConstants
} from 'store';

var initialState = {
	loading: false,
	error: null,
	applicationId: 0,
}

export function generalInfo(state = initialState, action) {
	switch (action.type) {
		case preAppConstants.RESET_APPLICATION_STATE:
			return {
				...initialState,
			};
		case generalInfoConstants.SEND_GENERAL_INFO_REQUEST:
			return {
				...state,
				loading: true,
			};
		case generalInfoConstants.SEND_GENERAL_INFO_SUCCESS:
			return {
				...state,
				loading: false,
			};
		case generalInfoConstants.SEND_GENERAL_INFO_ERROR:
			return {
				...state,
				error: action.error,
				loading: false,
			};
		case generalInfoConstants.GET_APPLICATION_ID_REQUEST:
			return {
				...state,
				loading: true,
			};
		case generalInfoConstants.GET_APPLICATION_ID_SUCCESS:
			return {
				...state,
				applicationId: action.result,
				loading: false,
			};
		case generalInfoConstants.GET_APPLICATION_ID_ERROR:
			return {
				...state,
				error: action.error,
				loading: false,
			};
		default:
			return state
	}
}